import React, {useState, useEffect} from "react";
import firebase from "../Firebase/index";
function MainContact(props){
    const isDarkTheme = props.isDarkTheme;
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [subject, setSubject] = useState('');

    const submitFirebase = () => {
        if(fullName !== '' && email !== '' && subject !== '' && message !== ''){
            const todoRef = firebase.database().ref("todo");
            const user = {
                fullName,
                email,
                subject,
                message
            }
            if(todoRef.push(user)){
                alert("Thank you for contacting");
                setFullName('');
                setEmail('');
                setSubject('');
                setMessage('');
            }
        }
        else{
            alert('Fill the all fields correctly!!')
        }

    }

    
    return(
        <>
            <div className={isDarkTheme ? 'dark-theme page' : 'light-theme page' }>
                <div className="page-heading">
                    <h1>CONTACT</h1>
                </div>
                <div className="half-split">
                    <div className="left-contact">
                        <div className="page-description contact">
                            <p>Looking for career in software or web development also interested in freelance opportunity.</p>
                            <p>However, if you have any other query then feel free to contact me.</p>
                        </div>
                        <div className="contact-form">
                            <form>
                                <div className="form-input">
                                    <div className="input-grid">
                                        <input type="text" placeholder="Full Name" name="name" 
                                            onChange={(e) => {
                                                setFullName(e.target.value)
                                                
                                            }}
                                            value={fullName}
                                            
                                        />
                                        <input type="email" placeholder="Email" name="email" 
                                            onChange={(e) => setEmail(e.target.value)}
                                            value={email}
                                        />
                                    </div>
                                </div>
                                <div className="form-input">
                                    <input type="text" placeholder="Subject" name="subject" 
                                        onChange={(e) => setSubject(e.target.value)}
                                        value={subject}
                                    />
                                </div>
                                <div className="form-input">
                                    <textarea placeholder="Message" type="text" name="message"  
                                        onChange={(e) => setMessage(e.target.value)}
                                        value={message}
                                    />
                                </div>
                                <button className="contact-btn" type="submit" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        submitFirebase();
                                    }}
                                >SEND MESSAGE</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default MainContact;